import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface DisputeButtonProps {
  onClick?: () => void;
}

const LANG_BASE = "vessel-call.operations";

const DisputeButton = ({ onClick }: DisputeButtonProps) => {
  return (
    <FlowActionButton
      langBase={LANG_BASE}
      permission={"canRequestDispute"}
      isActionAvailable={true}
      labelKey="dispute"
      testId="operations-dispute-button"
      type="button"
      variant="outlined"
      startIcon={<CancelOutlinedIcon />}
      onClick={() => onClick?.()}
    />
  );
};

export default DisputeButton;
